import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { UserDataStoreService } from "../../../services/user-data-store.service";
import { PermissionEnum } from "../../../services/guards/permissions";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { Select2OptionData } from 'ng-select2';
import { ContactDetailsViewModel } from '../../../models/contact-details-view-model';
import { Router } from '@angular/router';
import { AddUpdateTerminalSignUpViewModel, TerminalSignUpDownloadModel } from '../../../models/add-update-terminal-sign-up-view-model';
import { merchantTerminalsLink } from '../../../models/merchant-terminals-link';

@Component({
  selector: 'signup-summary-component',
  templateUrl: './signup-summary.component.html',
})
export class SignupSummaryComponent implements OnInit {

  SummaryFormGroup = new FormGroup({
    shopName: new FormControl(''),
    merchantNumber: new FormControl(''),
    merchantConfig: new FormControl(''),
    governmentMerchant: new FormControl(false),
    cardSet: new FormControl(''),
    country: new FormControl(''),
    region: new FormControl(''),
    town: new FormControl(''),
    merchantType: new FormControl(''),
    slipHeader: new FormControl(''),
    slipTrailer: new FormControl(''),
    merchantStreetAddress: new FormControl(''),
    subMerchantId: new FormControl(''),
    paymentFacilitatorId: new FormControl(''),
    paymentFacilitatorIdVisa: new FormControl(''),
    independentSalesOrganizationId: new FormControl(''),
    independentSalesOrganizationIdVisa: new FormControl(''),
    customerServicePhoneNo: new FormControl(''),
    merchantVerificationValue: new FormControl(''),
    notes: new FormControl(''),
    contactName: new FormControl(''),
    contactSurname: new FormControl(''),
    contactNumber: new FormControl(''),
    cellNumber: new FormControl(''),
    emailAddress: new FormControl(''),
    physicalAddress: new FormControl(''),
    terminalDelivery: new FormControl(''),
    terminals: new FormArray([])
  })

  ContactFormGroup: FormGroup;
  private merchantNumber: string;
  private canManage = false;
  public dtTrigger: Subject<boolean> = new Subject();
  @ViewChild(DataTableDirective)
  public countries: Select2OptionData[];
  _merchantComponent: FormGroup;
  _contactFormGroup: FormGroup;
  _contactModel: ContactDetailsViewModel;
  _terminalFormGroup: FormGroup;
  _terminalModelList: AddUpdateTerminalSignUpViewModel[];
  contactDetails: ContactDetailsViewModel;
  deviceList: TerminalSignUpDownloadModel[];
  public isbulkOrder = false;

  constructor(
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService,
    private _merchantTerminalsLink: merchantTerminalsLink) {
    this._ngxUiLoaderService.start();

    this.canManage = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantSignUp]);
    if (!this.canManage) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }
    this._ngxUiLoaderService.stop();
  }

  ngAfterViewInit() {
  }

  public ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  public ngOnInit(): void {
  }

  setSummaryData() {
    
    var merchant = this._merchantTerminalsLink.merchant;
    this.contactDetails = this._merchantTerminalsLink.contact;
    var contact = this._merchantTerminalsLink.contact;
    this.deviceList = this._merchantTerminalsLink.terminals;
    this.deviceList = this._merchantTerminalsLink.terminals;
    this.SummaryFormGroup = new FormGroup({
      shopName: new FormControl(merchant.shopName),
      merchantNumber: new FormControl(merchant.merchantNumber),
      merchantConfig: new FormControl(merchant.cardAcceptorConfigId),
      governmentMerchant: new FormControl(merchant.isGovernmentalMerchant),
      cardSet: new FormControl(merchant.cardSet),
      country: new FormControl(merchant.countryCode),
      region: new FormControl(merchant.regionCode),
      town: new FormControl(merchant.town),
      merchantType: new FormControl(merchant.merchantType),
      slipHeader: new FormControl(merchant.slipHeader),
      slipTrailer: new FormControl(merchant.slipTrailer),
      merchantStreetAddress: new FormControl(merchant.merchantStreetAddress),
      subMerchantId: new FormControl(merchant.subMerchantId),
      paymentFacilitatorId: new FormControl(merchant.paymentFacilitatorId),
      paymentFacilitatorIdVisa: new FormControl(merchant.paymentFacilitatorIdVisa),
      independentSalesOrganizationId: new FormControl(merchant.independentSalesOrgId),
      independentSalesOrganizationIdVisa: new FormControl(merchant.independentSalesOrgIdVisa),
      customerServicePhoneNo: new FormControl(merchant.customerServicePhoneNo),
      merchantVerificationValue: new FormControl(merchant.merchantVerificationValue),
      contactName: new FormControl(contact.firstName),
      contactSurname: new FormControl(contact.surname),
      contactNumber: new FormControl(contact.mobileNumber),
      cellNumber: new FormControl(contact.mobileNumber),
      emailAddress: new FormControl(contact.emailAddress),
      physicalAddress: new FormControl(this.deviceList[0].TerminalContactsViewModel.address),
      terminalDelivery: new FormControl(this.deviceList[0].deliveryMethod),
      notes: new FormControl(this._merchantTerminalsLink.notes),
      terminals: new FormArray([])
    })

    let terminals = this.SummaryFormGroup.get('terminals') as FormArray;

    for (let i = 0; i <= this.deviceList.length - 1; i++) {
      var _terminalType = this._merchantTerminalsLink.termTypes.find(item => item.id === this.deviceList[i].terminalType.toString()).text;
      terminals.push(new FormGroup({
        terminalConfigId: new FormControl(this.deviceList[i].terminalConfigId),
        terminalId: new FormControl(this.deviceList[i].terminalId),
        merchantNumber: new FormControl(this.merchantNumber),
        terminalNumber: new FormControl(this.deviceList[i].terminalNumber),
        terminalType: new FormControl(_terminalType),
        productProfile: new FormControl(this._merchantTerminalsLink.capabCommsProd.productProfile),
        terminalCapabilities: new FormControl(this._merchantTerminalsLink.capabCommsProd.terminalCapabilities),
        commsProfile: new FormControl(this._merchantTerminalsLink.capabCommsProd.commsProfile),
        manualPanEntry: new FormControl(this.deviceList[i].manualPanEntry),
        terminalActive: new FormControl(this.deviceList[i].terminalActive),
        contactless: new FormControl(this.deviceList[i].contactless),
        sameAsMerchantAddress: new FormControl(this.deviceList[i].sameAsMerchantAddress),
        deviceMake: new FormControl(this.deviceList[i].deviceMake),
        deviceModel: new FormControl(this.deviceList[i].deviceModel),
        deliveryMethod: new FormControl(this.deviceList[i].deliveryMethod),
        bulkOrder: new FormControl(this.deviceList[i].bulkOrder),
        bankingWindowTime: new FormControl(this.deviceList[i].bankingWindowTime),
        parameterDownloadDay: new FormControl(this.deviceList[i].parameterDownloadDay),
        parameterDownloadWindowTime: new FormControl(this.deviceList[i].parameterDownloadWindowTime),
        nameSurname: new FormControl(this.deviceList[i].TerminalContactsViewModel.nameSurname),
        ContactNameCellNr: new FormControl(this.deviceList[i].TerminalContactsViewModel.cell),
        ContactEmailAddress: new FormControl(this.deviceList[i].TerminalContactsViewModel.email),
        address: new FormControl(this.deviceList[i].TerminalContactsViewModel.address),
        region: new FormControl(this.deviceList[i].TerminalContactsViewModel.region),
        city: new FormControl(this.deviceList[i].TerminalContactsViewModel.city),
        postalcode: new FormControl(this.deviceList[i].TerminalContactsViewModel.postalcode)
      }))
    }
    this._merchantTerminalsLink.terminals = this.deviceList;
    
    this.isbulkOrder = this._merchantTerminalsLink.isbulkOrder;
  }
}
